const API_BASE = import.meta.env.VITE_API_BASE as string;

function errorMessage(status: number, body: string): string {
  // The API reports failures as {"error": "..."}; show that sentence rather
  // than a wall of JSON.
  try {
    const parsed = JSON.parse(body) as { error?: unknown };
    if (typeof parsed.error === "string" && parsed.error.trim()) return parsed.error;
  } catch {
    /* not JSON — fall through to the raw body */
  }
  return `API error ${status}: ${body.slice(0, 200)}`;
}

export class ApiError extends Error {
  constructor(public status: number, public body: string) {
    super(errorMessage(status, body));
  }
}

export async function api<T = unknown>(
  path: string,
  token: string | null,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers);
  headers.set("content-type", "application/json");
  if (token) headers.set("authorization", `Bearer ${token}`);

  const res = await fetch(`${API_BASE}${path}`, { ...init, headers });
  const text = await res.text();
  if (!res.ok) throw new ApiError(res.status, text);
  return text ? (JSON.parse(text) as T) : (undefined as T);
}
